import { render, staticRenderFns } from "./CrDocNoHelpList.vue?vue&type=template&id=36eee785&"
import script from "./CrDocNoHelpList.vue?vue&type=script&lang=js&"
export * from "./CrDocNoHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports